import React, { useState, useEffect } from "react";
import {Table, Spin, DatePicker} from "antd";
import CommonObj from "../../CommonObj";
import CalendarIcon from "../../assets/img/svg/xCalendaricon.svg?react";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useAuth } from "../../auth/AuthContext";
import "../reports/reports.css";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import "./recycleManifest.css";
import { renderCommonPaginationTotal } from "../../components/commonpagination/common-pagination";
import "../../components/commonpagination/common-pagination.css";
import { exportToCSV } from "../../components/exportToCsv";
import { message } from "../../components/antdMessageBridge";
import { buildTimestampedFileName } from "../../components/cstDateFileName";

const ShipmentHistory = (propData) => {
    const [data, setData] = useState(propData.data || []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchFilters, setsearchFilters] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const { roleUserId } = useAuth();
    const { accessToken, isAuthenticated } = useAuthToken();
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [startfloatLabel, setStartfloatLabel] = useState('');
    const [endfloatLabel, setEndfloatLabel] = useState('');
    const [errors, setErrors] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const [disabledCSVButton, setDisabledCSVButton] = useState(true);
    const [fileName, setFileName] = useState("");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
   
    useEffect(() => {
        console.log(propData.data);
        console.log(propData.component);
        setData([]);
        setSelectedStartDate(null);
        setSelectedEndDate(null);
        setStartfloatLabel("");
        setEndfloatLabel("");
        setFilteredData([]);
        setFileName("");
        setDisabledCSVButton(true);
        setErrors({});
        setPagination((prev) => ({
            ...prev,
            current: 1,
            total: 0,
        }));
    }, [propData.data, propData.component]);

    const validate = () => {
        const newErrors = {};
        if (!selectedStartDate) {
            newErrors.startdate = "Please select start date.";
        }
        if (!selectedEndDate) {
            newErrors.enddate = "Please select end date.";
        }
        if (selectedStartDate && selectedEndDate && new Date(selectedEndDate) < new Date(selectedStartDate)) {
            newErrors.datevalidate = "End Date cannot be lesser than Start Date";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleStartDateChange = (date) => {
        setErrors({});
        setSelectedStartDate(date);
        if (date !== null) {
            if (selectedEndDate !== null)
                setDisabledCSVButton(false);
            setStartfloatLabel('float-label');
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors.startdate;
                return newErrors;
            });
        } else {
            setStartfloatLabel('');
        }
    };

    const disableFutureDates = (current) => {
        const today = new Date();
        return current && current > today;
    };

    const handleEndDateChange = (date) => {
        setErrors({});
        setSelectedEndDate(date);
        if (date !== null) {
            if (selectedStartDate !== null)
                setDisabledCSVButton(false);
            setEndfloatLabel('float-label');
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors.enddate;
                return newErrors;
            });
        } else {
            setEndfloatLabel('');
        }
    };

    const handleCleardate = () => {
        setSelectedStartDate(null);
        setSelectedEndDate(null);
        setStartfloatLabel('');
        setEndfloatLabel('');
        setData([]);
        setFilteredData([]);
        setDisabledCSVButton(true);
        setErrors({});
        setPagination((prev) => ({
            ...prev,
            current: 1,
            total: 0,
        }));
        setFileName("");
    };
const handleDownloadClick = async () => {
    setFileName("");
    
    if (!validate()) {
        focusFirstErrorField();
        return;
    }

    await performDownload();
};

const focusFirstErrorField = () => {
    const firstErrorField = Object.keys(errors)[0];
    if (firstErrorField) {
        const element = document.getElementById(firstErrorField);
        if (element) element.focus();
    }
};

const performDownload = async () => {
    setLoading(true);
    setError(null);

    const payload = buildPayload();
    
    try {
        const responseData = await fetchReportData(payload);
        const processedData = processResponseData(responseData);
        if (processedData.length === 0) {
            message.error("No data found for selected date range.");
            setData([]);
            setPagination((prev) => ({
                ...prev,
                current: 1,
                total: 0,
            }));
            return false;
        }
        const filename = generateFileName();
        setFileName(filename);
        const activeColumns = (propData.component === "COD" ? columnsForCOD : columns);
        exportToCSV(processedData, activeColumns, filename);
        
    } catch (err) {
        setError(err.message);
    } finally {
        setLoading(false);
    }
};

const buildPayload = () => {
    const startdate = selectedStartDate ? selectedStartDate.format('YYYY-MM-DD') : null;
    const enddate = selectedEndDate ? selectedEndDate.format('YYYY-MM-DD') : null;
    
    return {
        "fromDate": startdate,
        "toDate": enddate,
        "createdBy": roleUserId,
        pageNo: 1,
        pageSize: -1,
        "reportName": propData.component
    };
};

const fetchReportData = async (payload) => {
    const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
        "Content-Type": "application/json",
    };
    
    const endpoint = propData.component === "COD" 
        ? CommonObj.Endpoints.GetRecycleCODHistory 
        : CommonObj.Endpoints.GetRecycleShipmentArchive;
    
    const response = await fetch(endpoint, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
    });

    if (!response.ok) throw new Error("Network response was not ok");

    const responseText = await response.text();
    return parseResponseText(responseText);
};

const parseResponseText = (responseText) => {
    try {
        const result = JSON.parse(responseText);
        return responseText.includes("No data found") ? [] : result;
    } catch (e) {
        if (responseText.includes("No data found")) {
            return [];
        }
        throw new Error(responseText || "Failed to parse API response.");
    }
};

const processResponseData = (result) => {
    const books = Array.isArray(result) ? result : [result];
    return books.map(row => ({
        ...row,
        codDateTime: row.codDateTime !== null ? `\t${row.codDateTime}` : "",
        shippedDateTime: `\t${row.shippedDateTime}`,
        weight: `\t${row.weight}`
    }));
};

const generateFileName = () => {
    const filename = propData.component === "COD" ? `COD_Archive` : `Shipment_Archive`;
    const dynamicFileName = buildTimestampedFileName(filename);
    return dynamicFileName + ".csv";
};


    const columns = [
        {
            title: "Recycle ID",
            dataIndex: "recycleBin",
            key: "recycleBin",
        },
        {
            title: "Total Book Count",
            dataIndex: "totalBookCount",
            key: "totalBookCount",
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
        },
        {
            title: "Shipped Date & Time",
            dataIndex: "shippedDateTime",
            key: "shippedDateTime",
        },
        {
            title: "Shipped By",
            dataIndex: "shippedBy",
            key: "shippedBy",
        },
        {
            title: "Load ID",
            dataIndex: "loadID",
            key: "loadID",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
    ];

    const columnsForCOD = [
        {
            title: "Load ID",
            dataIndex: "loadID",
            key: "loadID",
        },
        {
            title: "Recycle Bins",
            dataIndex: "recycleBin",
            key: "recycleBin",
        },
        {
            title: "Total Book Count",
            dataIndex: "totalBookCount",
            key: "totalBookCount",
        },
        {
            title: "Shipped Date & Time",
            dataIndex: "shippedDateTime",
            key: "shippedDateTime",
        },
        {
            title: "Shipped By",
            dataIndex: "shippedBy",
            key: "shippedBy",
        },
        {
            title: "COD#",
            dataIndex: "codNo",
            key: "codNo",
        },
        {
            title: "COD Date & Time",
            dataIndex: "codDateTime",
            key: "codDateTime",
        },
    ];

    const getRowClassName = (record, index) => {
        return index % 2 === 0 ? "odd-row" : "even-row";
    };

    const handleTableChange = (newPagination, filters, sorter) => {
        const normalizeFilters = {};
        Object.keys(filters).forEach((key) => {
            if (filters[key] && filters[key].length > 0) {
                normalizeFilters[key] = filters[key][0];
            }
        });
        setsearchFilters(normalizeFilters);
        setSortedInfo(sorter);
        // Keep pagination fully controlled
        setPagination((prev) => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        }));
        fetchData({
            pagination: {
                current: newPagination.current,
                pageSize: newPagination.pageSize,
            },
            sorter,
            filters: normalizeFilters,
        });
    };

    const fetchData = async ({ pagination: pag, filters, sorter }) => {
        setFilteredData([]);
        setFileName("");
        const startdate = selectedStartDate ? selectedStartDate.format('YYYY-MM-DD') : null;
        const enddate = selectedEndDate ? selectedEndDate.format('YYYY-MM-DD') : null;

        const payload = {
            "fromDate": startdate,
            "toDate": enddate,
            "createdBy": roleUserId,
            pageNo: pag?.current,
            pageSize: pag?.pageSize || 10,
            "reportName": "Shipment Report"
        };

        setLoading(true);
        try {
            const myHeaders = {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                "Content-Type": "application/json",
            };
            const response = await fetch((propData.component === "COD" ? CommonObj.Endpoints.GetRecycleCODHistory : CommonObj.Endpoints.GetRecycleShipmentArchive), {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
            });
            if (!response.ok) throw new Error("Network response was not ok");

            const responseText = await response.text();
            let result;

            try {
                result = JSON.parse(responseText);
            } catch (e) {
                if (responseText.includes("No shipments found.")) {
                    result = [];
                } else {
                    throw new Error(responseText || "Failed to parse API response.");
                }
            }
            const shipments = Array.isArray(result) ? result : [result];
            const formattedData = shipments.map((item) => ({
                ...item,
                key: item.recycleBin
            }));
            setData(formattedData);
            const total = formattedData[0]?.totalRows || 10;
            setPagination((prev) => ({
                ...prev,
                current: pag?.current || prev.current,
                pageSize: pag?.pageSize || prev.pageSize,
                total,
            }));
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData({ pagination, sorter: sortedInfo, filters: searchFilters });
    },[]);

    if (loading) {
        return (
            <Spin size="large" style={{ margin: "20px auto" }} />
        );
    }

    return (
        <div className="active-page-container">
             <div className="advance-filter-container">
                <div className={"shipment-subTitle"}><span> Search shipments by "<b style={{ fontWeight: "700" }}>Date Range</b>"</span></div>
                <div className="advance-filter-body-container">
                    <div className="advance-filter-input-container">
                        <div className="advance-filter-input-width">
                            <div className="field-group">
                                <DatePicker variant="underlined" placeholder=""
                                    className={`${"book-page-form-input-text"} ${selectedStartDate === null ? "" : "has-text"}`}
                                    suffixIcon={<CalendarIcon />}
                                    value={selectedStartDate}
                                    onChange={handleStartDateChange}
                                    disabledDate={disableFutureDates}
                                    allowClear={false} id="startdate-report-1"
                                />
                                <label className={startfloatLabel} htmlFor="startdate-report-1">
                                    Start Date <span className="form-required">*</span>
                                </label>
                                {errors.startdate && (
                                    <span className="error-msg">{errors.startdate}</span>
                                )}
                                {errors.datevalidate && (
                                    <span className="error-msg-1">{errors.datevalidate}</span>
                                )}
                            </div>
                        </div>
                        <div className="advance-filter-input-width">
                            <div className="field-group">
                                <DatePicker variant="underlined" placeholder=""
                                    className={`${"book-page-form-input-text"} ${selectedEndDate === null ? "" : "has-text"}`}
                                    suffixIcon={<CalendarIcon />}
                                    value={selectedEndDate}
                                    onChange={handleEndDateChange}
                                    disabledDate={disableFutureDates}
                                    allowClear={false} id="enddate-report-1"
                                />
                                <label htmlFor="enddate-report-1" className={endfloatLabel}>
                                    End Date <span className="form-required">*</span>
                                </label>
                                {errors.enddate && (
                                    <span className="error-msg">{errors.enddate}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="advance-filter-button-container">
                        <button className="cancel-button-gray-outline" onClick={handleCleardate}>Clear</button>
                        <button className="submit-button-gradiant-outline"
                            data-track={propData.component === "COD" ? "codArchive-generate" : "shipmentArchive-generate"}
                            onClick={(e) => {
                            e.preventDefault();
                            if (!validate()) {
                                const firstErrorField = Object.keys(errors)[0];
                                if (firstErrorField) {
                                    const element = document.getElementById(firstErrorField);
                                    if (element) element.focus();
                                }
                                return;
                            }
                            const resetPagination = {
                                ...pagination,
                                current: 1
                            };
                            setPagination(resetPagination);
                            fetchData({
                                pagination: resetPagination,
                                sorter: sortedInfo,
                                filters: searchFilters
                            });
                        }}>Generate</button>
                       
                        <button className={disabledCSVButton ? "submit-button-gradiant-outline disabled_button" :"submit-button-gradiant-outline" }
                            data-track={propData.component === "COD" ? "codArchive-exportCsv" : "shipmentArchive-exportCsv"}
                            onClick={handleDownloadClick}
                            disabled={disabledCSVButton}
                        >
                            {loading ? 'Processing...' : 'Export as CSV'}
                        </button>
                    </div>
                </div>
            </div>
            <div className="active-page-body-container">
                <div className="rounded-table-wrapper">
                    <Table
                        columns={(propData.component === "COD" ? columnsForCOD :columns)}
                        dataSource={data}
                        className="common-pagination common-grid"
                        pagination={{
                            ...pagination,
                              pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
                            showSizeChanger: true,
                            position: ["bottomRight"],
                            defaultPageSize: 10,
                            showTotal: (total, range) =>
                                renderCommonPaginationTotal(total, range, {
                                    pagination,
                                    handleTableChange,
                                    searchFilters,
                                    sortedInfo
                                }),
                        }}
                        rowKey={(record) => (propData.component === "COD" ? record.loadID : record.recycleBin) }
                        onChange={handleTableChange}
                        scroll={{ x: "max-content", y: "calc(100vh - 370px)" }}
                        rowClassName={getRowClassName}
                    />
                </div>
            </div>
        </div>
    );
};
export default ShipmentHistory;
